import { render } from "./students.vue?vue&type=template&id=e230fa64&scoped=true"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"

import "./students.vue?vue&type=style&index=0&id=e230fa64&scoped=true&lang=css"
import "./students.vue?vue&type=style&index=1&id=e230fa64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e230fa64"]])

export default __exports__